module.exports = __webpack_public_path__ + "06f66cc0df37fe242f470727ded339e0.svg";